export default __webpack_public_path__ + "static/media/step2-min.f94109c2.webp";